import {
  SET_JOB_DATA,
  SET_JOB_DETAIL_DATA,
  SET_ONLINE_STATUS,
  RESET_ONLINE_STATUS,
} from "./action.types";

export const setJobs = (payload) => ({ type: SET_JOB_DATA, payload });

export const setJobDetail = (payload) => ({
  type: SET_JOB_DETAIL_DATA,
  payload,
});

export const setOnlineStatus = (payload) => ({
  type: SET_ONLINE_STATUS,
  payload,
});

export const resetOnlineStatus = () => ({ type: RESET_ONLINE_STATUS });
